var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("订单管理")]),
            ]),
            _c("el-breadcrumb-item", { attrs: { to: { name: "orderList" } } }, [
              _c("div", { staticClass: "div3" }, [_vm._v("我的订单")]),
            ]),
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div2" }, [_vm._v("修改订单")]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "basic" }, [
      _c("p", { staticClass: "header" }, [_vm._v("基本信息")]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                inline: true,
                model: _vm.form,
                "label-width": "80px",
                disabled: "",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "入线方式" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "选择入线方式" },
                      model: {
                        value: _vm.form.Incoming,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "Incoming", $$v)
                        },
                        expression: "form.Incoming",
                      },
                    },
                    _vm._l(_vm.line, function (items) {
                      return _c("el-option", {
                        key: items.id,
                        attrs: { label: items.name, value: items.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客户意向" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "选择客户意向" },
                      model: {
                        value: _vm.form.intention,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "intention", $$v)
                        },
                        expression: "form.intention",
                      },
                    },
                    _vm._l(_vm.intention, function (items) {
                      return _c("el-option", {
                        key: items.id,
                        attrs: { label: items.name, value: items.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客户等级" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "选择客户等级" },
                      model: {
                        value: _vm.form.category,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "category", $$v)
                        },
                        expression: "form.category",
                      },
                    },
                    _vm._l(_vm.rank, function (items) {
                      return _c("el-option", {
                        key: items.id,
                        attrs: { label: items.name, value: items.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客户姓名" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户姓名" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客户性别" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "选择性别" },
                      model: {
                        value: _vm.form.sex,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "sex", $$v)
                        },
                        expression: "form.sex",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "男", value: "1" } }),
                      _c("el-option", { attrs: { label: "女", value: "2" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客户年龄" } },
                [
                  _c("el-input", {
                    attrs: { type: "number", placeholder: "请输入客户年龄" },
                    model: {
                      value: _vm.form.age,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "age", $$v)
                      },
                      expression: "form.age",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系电话" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户电话" },
                    model: {
                      value: _vm.form.phone1,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone1", $$v)
                      },
                      expression: "form.phone1",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "联系二" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户电话" },
                    model: {
                      value: _vm.form.phone2,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "phone2", $$v)
                      },
                      expression: "form.phone2",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "receipt" }, [
      _c("p", { staticClass: "header" }, [_vm._v("收货地址")]),
      _vm.disabledIf
        ? _c(
            "div",
            { staticClass: "determination" },
            [
              _c(
                "el-form",
                {
                  ref: "address",
                  attrs: {
                    inline: true,
                    model: _vm.address,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "收货人姓名" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入客户姓名" },
                        model: {
                          value: _vm.address.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.address, "name", $$v)
                          },
                          expression: "address.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系电话" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入收货电话" },
                        model: {
                          value: _vm.address.phone,
                          callback: function ($$v) {
                            _vm.$set(_vm.address, "phone", $$v)
                          },
                          expression: "address.phone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "收货地址" } },
                    [
                      _c("levelAddr", {
                        staticClass: "addressContent",
                        attrs: {
                          province: _vm.address.province,
                          city: _vm.address.city,
                          area: _vm.address.area,
                        },
                        on: {
                          updateprovice: _vm.getProvince,
                          updatecity: _vm.getCity,
                          updatearea: _vm.getArea,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "详细地址" } },
                    [
                      _c("el-input", {
                        staticClass: "address",
                        attrs: { placeholder: "请输入客户详细地址" },
                        on: { blur: _vm.getAddObj },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.getAddObj.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.address.datail,
                          callback: function ($$v) {
                            _vm.$set(_vm.address, "datail", $$v)
                          },
                          expression: "address.datail",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.disabledIf
        ? _c("div", { staticClass: "submitAddress" }, [
            _c(
              "p",
              [
                _c("span", { staticStyle: { "margin-right": "20px" } }, [
                  _vm._v(
                    "姓名: " +
                      _vm._s(
                        _vm.referaddress.addressName
                          ? _vm.referaddress.addressName
                          : _vm.referaddress.userName
                      )
                  ),
                ]),
                _c("span", { staticStyle: { "margin-right": "20px" } }, [
                  _vm._v(
                    "号码: " +
                      _vm._s(
                        _vm.referaddress.addressPhone
                          ? _vm.referaddress.addressPhone
                          : _vm.referaddress.phone
                      )
                  ),
                ]),
                _c("span", [
                  _vm._v("地址: " + _vm._s(_vm.referaddress.address)),
                ]),
                _vm.referaddress.isDefault == 1
                  ? _c(
                      "el-tag",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { type: "primary", size: "mini" },
                      },
                      [_vm._v("默认收货地址")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "orderBox" }, [
      _c(
        "div",
        { staticClass: "order" },
        [
          _c(
            "p",
            {
              staticClass: "headerOrder",
              staticStyle: { background: "#fff", padding: "10px" },
            },
            [
              _c("span", [_vm._v("订单商品")]),
              !_vm.disabledIf && _vm.parArray.indexOf("dshtjxgdd") != -1
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.addgoods },
                    },
                    [_vm._v("添加/修改商品")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.tableData } },
            [
              _c("el-table-column", {
                attrs: { label: "商品名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("p", [_vm._v(_vm._s(scope.row.title))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品数量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "numer" }, [
                          _c("span", [_vm._v(_vm._s(scope.row.number))]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品单价" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("p", [_vm._v(_vm._s(scope.row.sellPrice))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "brandId", label: "商品品牌" },
              }),
              _c("el-table-column", {
                attrs: { prop: "typeId", label: "商品分类" },
              }),
              _c("el-table-column", {
                attrs: { prop: "specificationName", label: "商品规格" },
              }),
              _c("el-table-column", {
                attrs: { prop: "total", label: "商品小计" },
              }),
            ],
            1
          ),
          _c(
            "el-table",
            { staticStyle: { width: "100%" }, attrs: { data: _vm.tableZp } },
            [
              _c("el-table-column", {
                attrs: { label: "赠品名称" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("p", [_vm._v(_vm._s(scope.row.title))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "赠品数量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "numer" }, [
                          _c("span", [_vm._v(_vm._s(scope.row.number))]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "赠品单价" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("p", [_vm._v(_vm._s(scope.row.sellPrice))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "brandId", label: "商品品牌" },
              }),
              _c("el-table-column", {
                attrs: { prop: "categoryId", label: "商品分类" },
              }),
              _c("el-table-column", {
                attrs: { prop: "specificationName", label: "赠品规格" },
              }),
              _c("el-table-column", {
                attrs: { prop: "total", label: "赠品小计" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "orderNotes" }, [
        _c("div", { staticClass: "headerOrder" }, [
          _c("span", [_vm._v("订单备注")]),
          !_vm.disabledIf
            ? _c(
                "div",
                { staticClass: "btn" },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "float-left avatar-uploader",
                      attrs: {
                        "list-type": "picture",
                        action: "#",
                        "show-file-list": false,
                        "http-request": _vm.safeImport,
                        "auto-upload": true,
                        "file-list": _vm.fileList,
                        multiple: true,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "trigger",
                            size: "mini",
                            type: "primary",
                          },
                          slot: "trigger",
                        },
                        [_vm._v("上传凭证")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "notes" },
          [
            _c("el-input", {
              attrs: { type: "textarea", placeholder: "备注" },
              model: {
                value: _vm.textarea,
                callback: function ($$v) {
                  _vm.textarea = $$v
                },
                expression: "textarea",
              },
            }),
            _vm._l(_vm.fileList, function (item, index) {
              return _c("p", { key: index }, [
                !_vm.is_null(_vm.fileList)
                  ? _c("img", {
                      directives: [
                        { name: "image-preview", rawName: "v-image-preview" },
                      ],
                      staticClass: "avatar",
                      attrs: { src: _vm.ImgHttps + item.img },
                    })
                  : _vm._e(),
                !_vm.is_null(_vm.fileList)
                  ? _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.close(index)
                          },
                        },
                      },
                      [_vm._v("×")]
                    )
                  : _vm._e(),
              ])
            }),
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "page1" }, [
        _c("p", [
          _c("span", [_vm._v("总计：共 " + _vm._s(_vm.orderNumber) + " 件 ")]),
        ]),
        _c("p", [
          _c("span", [_vm._v("赠品总价：" + _vm._s(_vm.giftPrice) + " ")]),
        ]),
        _c(
          "p",
          [
            _c("span", [_vm._v("总价:")]),
            _c("el-input", {
              attrs: { disabled: _vm.disabledIf },
              model: {
                value: _vm.total,
                callback: function ($$v) {
                  _vm.total = $$v
                },
                expression: "total",
              },
            }),
          ],
          1
        ),
        _c(
          "p",
          [
            _c("span", [_vm._v("已收款:")]),
            _c("el-input", {
              attrs: { disabled: _vm.disabledIf },
              model: {
                value: _vm.receivedMoney,
                callback: function ($$v) {
                  _vm.receivedMoney = $$v
                },
                expression: "receivedMoney",
              },
            }),
          ],
          1
        ),
        _c("p", [
          _c("span", { staticStyle: { color: "#999" } }, [
            _vm._v("原总价：" + _vm._s(_vm.origTotal)),
          ]),
        ]),
        _vm.parArray.indexOf("jlSign") != -1 && _vm.positionCode != "manager"
          ? _c(
              "p",
              [
                _c("span", [_vm._v("经理签字：")]),
                _c(
                  "el-radio-group",
                  {
                    staticStyle: { "margin-top": "3px" },
                    attrs: { disabled: _vm.isTurnManager },
                    model: {
                      value: _vm.isManager,
                      callback: function ($$v) {
                        _vm.isManager = $$v
                      },
                      expression: "isManager",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")]),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "p",
          [
            !_vm.disabledIf && _vm.parArray.indexOf("dshtjxgdd") != -1
              ? _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.trueOrder },
                  },
                  [_vm._v("确定修改")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "p",
          [
            _vm.disabledIf && _vm.parArray.indexOf("fixApproveback") != -1
              ? _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.keepAddress("批准")
                      },
                    },
                  },
                  [_vm._v("通过审核")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "p",
          [
            _vm.disabledIf && _vm.parArray.indexOf("fixApproveback") != -1
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.rejectEvent("驳回")
                      },
                    },
                  },
                  [_vm._v("驳回")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }